import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';

import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

export type ContextMenuButtonClickedArgs = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
};

export const onContextMenuButtonClicked = ({
	commonAttributes,
	nonPrivacySafeAttributes,
}: ContextMenuButtonClickedArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}ContextMenuButton`,
	action: 'clicked',
	attributes: {
		additionalAttributes: {
			location: 'searchResultTitle',
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
